<div *ngIf="showBanner" class="cookie-consent-banner">
  <p>This website uses cookies to ensure you get the best experience on our website. 
    <a href="#" (click)="$event.preventDefault()">Learn more</a>
  </p>
  <button (click)="acceptCookies()">Accept</button>
</div>
